import { render, staticRenderFns } from "./DsHome.vue?vue&type=template&id=0e64b5a5"
import script from "./DsHome.vue?vue&type=script&lang=js"
export * from "./DsHome.vue?vue&type=script&lang=js"
import style0 from "./home.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports